/**
 * The registered business address, as given by the owner on 2026-09-23. One
 * definition, rendered on the policy/contact pages and in the Organization
 * JSON-LD, so the visible text and the structured data cannot disagree.
 */
const BUSINESS_ADDRESS = {
  streetAddress: "Old Char Chaman",
  addressLocality: "Karnal",
  addressRegion: "Haryana",
  postalCode: "132001",
  addressCountry: "IN",
} as const;

/** "Old Char Chaman, Karnal, Haryana 132001, India" */
export const BUSINESS_ADDRESS_TEXT = `${BUSINESS_ADDRESS.streetAddress}, ${BUSINESS_ADDRESS.addressLocality}, ${BUSINESS_ADDRESS.addressRegion} ${BUSINESS_ADDRESS.postalCode}, India`;

/** schema.org PostalAddress for the Organization node. */
export const BUSINESS_POSTAL_ADDRESS = {
  "@type": "PostalAddress",
  ...BUSINESS_ADDRESS,
} as const;
